/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import i18n from "i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  Container,
  Nav,
  Navbar,
  Card,
  Col,
  Row,
  Button,
} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { compose } from "redux";
import AppPaths from "../../../../routes/AppPaths";
import { getCurrentUser, getRevenue } from "../../../../store/actions/index";
import * as actions from "../../../../store/actions/index";
import "./Header.scss";
import {
  getLanguageId,
  setLanguageId,
  getUserTypeWiseDisplay,
  setLanguageCode,
} from "../../../../helpers/helpers";
import { getBaseImageURL } from "../../../../helpers/url";
import profilePhoto from "../../assets/images/account.png";
import defaultFavicon from "../../assets/images/favicon.png";
import {
  preloadDashboardData,
  preloadWalletData,
  preloadUserProfileData,
  preloadMyinvestmentData,
  preloadMangoPayData,
  preloadEquityShareCertificateData,
} from "../../../../helpers/swrPreloadHelper";
import ChangeLanguage from "../Footer/ChangeLanguage/ChangeLanguage";
import { decryptedData } from "../../../../helpers/encryptDecryptData";
import { isRTL, secondaryMarketConstants } from "../../../../constants";
import classNames from "classnames";

function Header(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userTypeId = localStorage.getItem("userType");
  const globalImagePath = useRef(getBaseImageURL());
  const location = useLocation();
  const isHome = location.pathname === "/";
  const isSavedInvestmentEnable = useRef(
    process.env.REACT_APP_TOGGLE_SAVED_INVESTMENT === "true"
  );
  const isEncryted = useRef(
    process.env.REACT_APP_DATABASE_ENCRYPTION === "true"
  );

  useEffect(() => {
    localStorage.getItem("token") && dispatch(getCurrentUser());
    dispatch(getRevenue());
    dispatch(actions.getCurrentLanguage());
    if (
      userTypeId !== null &&
      userTypeId !== undefined &&
      userTypeId !== "undefined"
    ) {
      dispatch(actions.userTypes(userTypeId));
    } else {
      dispatch(actions.userTypes(""));
    }
  }, [dispatch, userTypeId]);

  const { siteSettings } = props;
  const { currentLang, defaultLang } = useSelector((state) => state.languages);
  
  const { equityShareCertificates } = useSelector(
    (state) => state.siteSettings
  );
  const { userTypes } = useSelector((state) => state.userRegistration);
  const { walletSelectedCurrency } = useSelector((state) => state.wallet);

  const [displayData, setDisplayData] = useState("");
  const [showSubMenu, setShowSubMenu] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [logo, setLogo] = useState();
  const [expanded, setExpanded] = useState(false);
  const [headerBgColor, setHeaderBgColor] = useState(false);

  // Extracting response from API Call

  const { currentUser } = useSelector(
    (state) => state.getCurrentUser,
    shallowEqual
  );

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 1) {
        setHeaderBgColor("#E6F3E2");
      } else {
        setHeaderBgColor("transparent");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setMobileMenu(window.innerWidth < 992);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [window.innerWidth]);

  useEffect(() => {
    if (siteSettings?.siteLogo) {
      setLogo(siteSettings?.siteLogo);
    }
  }, [siteSettings?.siteLogo]);

  useEffect(() => {
    if (userTypes) {
      getUserTypeWiseDisplay(
        userTypes,
        siteSettings?.onlyAdminCreateCampaign,
        currentUser
      );
      setDisplayData(JSON.parse(localStorage.getItem("displayData")));
    }
  }, [userTypes, currentUser, siteSettings]);

  useEffect(() => {
    if (
      getLanguageId() === null &&
      currentLang !== null &&
      currentLang !== undefined
    ) {
      setLanguageId(currentLang);
      setLanguageCode(defaultLang?.folder);
      window.location.reload();
    }
  }, [currentLang]);

  const { header } = useSelector((state) => state.menu, shallowEqual);
  const { meta } = useSelector((state) => state.meta);
  const { taxonomy } = useSelector((state) => state?.taxonomy);
  const { isAuth, t } = props;
  const { firstName, favIcon } = siteSettings;

  const faviconPath = useMemo(() => {
    return siteSettings?.favIcon
      ? `${globalImagePath?.current}${siteSettings?.favIcon}`
      : defaultFavicon;
  }, [siteSettings?.favIcon, globalImagePath?.current]);

  useEffect(() => {
    const fav = document.getElementById("favicon");
    if (fav && fav.href !== faviconPath) {
      fav.href = faviconPath;
    }
  }, [faviconPath]);

  // Set the Website title Dynamically
  if (
    !document.location.href.includes("/campaign-detail-page/") &&
    !document.location.href.includes("/campaign-dashboard/") &&
    !document.location.href.includes("/content-page/")
  ) {
    const title = meta && meta?.siteName;
    document.title =
      title === undefined ? i18n.t("header.welcomeTitle") : title;
  }

  // Set the Menus
  const menus =
    header.length > 0
      ? header.map((menu, key) =>
          menu.linkType === "custom" ? (
            <a
              key={key}
              className="nav-link"
              href={menu?.customUrl}
              target={menu?.urlTarget}
            >
              {menu?.title}
            </a>
          ) : (
            <Link
              key={key}
              className="nav-link"
              to={`/content-page/${menu?.contentPage?.slug}`}
              target={menu?.urlTarget}
            >
              {menu?.title}
            </Link>
          )
        )
      : null;

  return (
    <>
      <Navbar
        id="mainSiteHeader"
        expand="lg"
        expanded={expanded}
        className="ec-navbar flex-column"
        style={{ backgroundColor: headerBgColor }}
        data-test="component-header"
      >
        <Container fluid>
          {/* logo */}
          <Link
            id="headerLogoHomePath"
            className="mx-lg-5 "
            to={AppPaths.HOME_PATH}
            data-test="component-header-logo"
            onMouseEnter={() => {
              setLogo(siteSettings?.siteLogo);
            }}
            onMouseLeave={() => {
              setLogo(siteSettings?.siteLogo);
            }}
          >
            <img
              className="primary-site-logo"
              src={`${globalImagePath.current}${logo}`}
              alt=""
            />
          </Link>

          {/* menu */}
          <div>
            <span className="d-lg-none">
              <ChangeLanguage />
            </span>
            <Button
              onClick={() => setExpanded((prev) => !prev)}
              className={classNames(
                "basic-navbar-nav navbar-toggler d-flex align-items-center d-lg-none mt-2",
                isRTL ? "me-auto" : "ms-auto"
              )}
            >
              <FontAwesomeIcon icon="fa-solid fa-bars" />
            </Button>
          </div>
          {/* <Navbar.Toggle aria-controls="basic-navbar-nav custom-navbar-toggler" /> */}
          <Navbar.Collapse
            id="basic-navbar-nav custom-navbar-wrap"
            style={
              showSubMenu && mobileMenu
                ? {
                    height: "80vh",
                    overflowY: "auto",
                    transition: "all 0.5s ease-in-out",
                  }
                : {}
            }
          >
            <Nav className="">
              {isAuth ? (
                <>
                  <Link
                    className="nav-link"
                    id="headerMenuHome"
                    to={AppPaths.HOME_PATH}
                  >
                    {t("header.home")}
                  </Link>
                  {menus}
                  <Link
                    id="headerMenuBrowse"
                    className="nav-link"
                    to={AppPaths.BROWSE_PATH}
                  >
                    {t("menu.browse")}
                  </Link>
                  <Link
                    className="nav-link"
                    id="headerMenuContactUs"
                    to={AppPaths.CONTACT_US_PATH}
                  >
                    {t("footerLink.contactUs")}
                  </Link>
                  {/* {displayData?.campaignOwnerDisplay && (
                    <Link
                      id="headerCreateCampaign"
                      className="nav-link"
                      to={
                        siteSettings?.plaidDwollaModule === "yes"
                          ? currentUser?.plaidDwollaCustomerId &&
                            currentUser?.plaidDwollaKYCStatus === "verified"
                            ? AppPaths.PROJECT_GUIDELINES
                            : `${AppPaths.HOME_PATH}?notify=completeYourKYC`
                          : AppPaths.PROJECT_GUIDELINES
                      }
                    >
                      {t("header.createCampaign")}
                    </Link>
                  )} */}
                  <Card.Body className="nav-link nav-user-dropdown-wrapper d-lg-none">
                    <Card.Body
                      className="nav-user-info ml-auto"
                      onClick={() => setShowSubMenu(!showSubMenu)}
                      data-test="component-header-placeholder-avatar"
                    >
                      <img
                        src={
                          currentUser?.photo
                            ? currentUser?.photo?.includes("users/user") ||
                              currentUser?.photo?.includes("admins/admin")
                              ? `${globalImagePath.current}${currentUser?.photo}`
                              : `${currentUser?.photo}`
                            : profilePhoto
                        }
                        className="nav-user-img"
                        alt={firstName}
                        onMouseEnter={() => setShowSubMenu(true)}
                      />
                      <span className="nav-user-name">
                        {isEncryted.current
                          ? decryptedData(currentUser?.firstName)
                          : currentUser?.firstName}{" "}
                        {isEncryted.current
                          ? decryptedData(currentUser?.lastName)
                          : currentUser?.lastName}
                      </span>
                      <FontAwesomeIcon
                        className="nav-user-arrow"
                        icon={[
                          "fas",
                          showSubMenu ? "chevron-up" : "chevron-down",
                        ]}
                      />
                    </Card.Body>
                    <Card.Body
                      className="nav-user-dropdown"
                      data-test="component-header-user-dropdown"
                    >
                      {showSubMenu ? (
                        <Card.Body className="nav-user-dropdown-inner">
                          {displayData?.investorDisplay ? (
                            <Link
                              id="headerInvestments"
                              className="nav-user-dropdown-item"
                              to={AppPaths.INVESTMENTS_PATH}
                              onClick={() => setShowSubMenu(false)}
                              onMouseEnter={() => preloadMyinvestmentData()}
                            >
                              {t("header.investorDashboard")}
                            </Link>
                          ) : (
                            ""
                          )}

                          {equityShareCertificates?.length > 0 &&
                          siteSettings?.enableShareCertificate === "yes" ? (
                            <Link
                              id="headerShareCertificates"
                              className="nav-user-dropdown-item"
                              to={AppPaths.SHARE_CERTIFICATES_PATH}
                              onClick={() => setShowSubMenu(false)}
                              onMouseEnter={() =>
                                preloadEquityShareCertificateData()
                              }
                            >
                              {t("header.shareCertificate")}
                            </Link>
                          ) : (
                            ""
                          )}

                          {/* {siteSettings?.enableSecondaryMarket ===
                            secondaryMarketConstants.ENABLE && (
                            <Link
                              id="headerSecondaryMarket"
                              to={
                                AppPaths.SECONDARY_MARKET_SELLER_DASHBOARD_PATH
                              }
                              className="nav-user-dropdown-item"
                            >
                              {t("header.secondaryMarket")}
                            </Link>
                          )} */}

                          {displayData?.campaignOwnerDisplay ? (
                            <Link
                              id="headerDashboard"
                              className="nav-user-dropdown-item"
                              to={AppPaths.DASHBOARD_PATH}
                              onClick={() => setShowSubMenu(false)}
                              onMouseEnter={() => preloadDashboardData()}
                            >
                              {t("header.campaignDashboard", {
                                value: taxonomy?.projectSingular,
                              })}
                            </Link>
                          ) : (
                            ""
                          )}
                          <Link
                            id="headerProfilePage"
                            className="nav-user-dropdown-item"
                            to={`/profile/${localStorage.getItem("slug")}`}
                            onClick={() => setShowSubMenu(false)}
                            onMouseEnter={() =>
                              preloadUserProfileData(
                                localStorage.getItem("slug"),
                                props?.currentUser?.id
                              )
                            }
                          >
                            {t("header.myProfile")}
                          </Link>
                          <Link
                            id="headerSavedCampaign"
                            className="nav-user-dropdown-item"
                            to={AppPaths.SAVED_CAMPAIGN_PATH}
                            onClick={() => setShowSubMenu(false)}
                          >
                            {t("header.savedCampaign", {
                              value: taxonomy?.projectPlural,
                            })}
                          </Link>
                          {isSavedInvestmentEnable.current ? (
                            <Link
                              id="headerSavedInvestment"
                              className="nav-user-dropdown-item"
                              to={AppPaths.SAVED_INVESTMENT_PATH}
                              onClick={() => setShowSubMenu(false)}
                            >
                              {t("header.savedInvestment")}
                            </Link>
                          ) : null}
                          {/* Comment : this below message functionality is not used anywhere */}

                          {/* <Link
                        		id="headerInbox"
                        		className="nav-user-dropdown-item dropdown-item-messages"
                        		to={AppPaths.INBOX_PATH}
                        		onClick={() => setShowSubMenu(false)}
                        	>
                        		{t("header.messages")}
                        	</Link> */}
                          <Link
                            id="headerNotification"
                            className="nav-user-dropdown-item dropdown-item-notifications"
                            to={AppPaths.USER_NOTIFICATION_PATH}
                            onClick={() => {
                              dispatch(actions.postUserNotifications());
                              setShowSubMenu(false);
                            }}
                          >
                            {t("header.notifications")}
                          </Link>
                          <Link
                            id="headerInvite"
                            className="nav-user-dropdown-item"
                            to={AppPaths.INVITE_PATH}
                            onClick={() => setShowSubMenu(false)}
                          >
                            {t("header.inviteFriends")}
                          </Link>
                          {siteSettings?.walletModule === "yes" ? (
                            <Link
                              id="headerProfileSetting"
                              className="nav-user-dropdown-item"
                              to={AppPaths.WALLET_PATH}
                              onClick={() => setShowSubMenu(false)}
                              onMouseEnter={() =>
                                preloadWalletData(
                                  walletSelectedCurrency?.id ||
                                    siteSettings?.currencyId?.id
                                )
                              }
                            >
                              {t("wallet.title")}
                            </Link>
                          ) : null}
                          {siteSettings?.mangoPayModule === "yes" ? (
                            <Link
                              id="headerProfileSetting"
                              className="nav-user-dropdown-item"
                              to={AppPaths.MANGOPAY_PATH}
                              onClick={() => setShowSubMenu(false)}
                              onMouseEnter={() =>
                                preloadMangoPayData(
                                  siteSettings?.mangoPayCurrencyId?.id
                                )
                              }
                            >
                              {t("header.mangoPayWallet")}
                            </Link>
                          ) : null}
                          <Link
                            id="headerProfileSetting"
                            className="nav-user-dropdown-item"
                            to={AppPaths.PROFILE_SETTINGS_PATH}
                            onClick={() => setShowSubMenu(false)}
                          >
                            {t("header.settings")}
                          </Link>

                          <Link
                            id="headerLogout"
                            className="nav-user-dropdown-item"
                            data-test="component-header-logout"
                            to={AppPaths.LOGOUT_PATH}
                            onClick={() => setShowSubMenu(false)}
                          >
                            {t("header.logout")}
                          </Link>
                        </Card.Body>
                      ) : null}
                    </Card.Body>
                  </Card.Body>
                  {displayData?.headerRaiseCapital && (
                    <Button
                      onClick={() => navigate(AppPaths.PROJECT_GUIDELINES)}
                      className="square-btn square-btn-shadow d-lg-none"
                    >
                      {i18n.t("header.getStarted")}
                    </Button>
                  )}
                </>
              ) : (
                <>
                  <Link
                    className="nav-link"
                    id="headerMenuHome"
                    to={AppPaths.HOME_PATH}
                  >
                    {t("header.home")}
                  </Link>
                  {menus}
                  <Link
                    id="headerMenuBrowsePublic"
                    className="nav-link"
                    to={AppPaths.BROWSE_PATH}
                  >
                    {t("menu.browse")}
                  </Link>
                  <Link
                    className="nav-link"
                    id="headerMenuContactUs"
                    to={AppPaths.CONTACT_US_PATH}
                  >
                    {t("footerLink.contactUs")}
                  </Link>
                  <Link
                    id="headerLogin"
                    className=" me-0"
                    to={AppPaths.LOGIN_PATH}
                    data-test="component-header-login"
                  >
                    <Button
                      variant="outline-light"
                      className="me-2 mt-2 square-btn header-square-btn d-lg-none"
                    >
                      {t("menu.signIn")}
                    </Button>
                  </Link>
                  <Link
                    id="headerSignup"
                    className="nav-link btn btn-primary square-btn square-btn-shadow d-lg-none mt-2"
                    to={AppPaths.SIGNUP_PATH}
                  >
                    {t("menu.signUp")}
                  </Link>
                </>
              )}
            </Nav>
          </Navbar.Collapse>

          <Card.Body className="ms-auto d-flex gap-3 align-items-center justify-content-end d-none d-lg-flex">
            {isAuth ? (
              <>
                <Row style={{ justifyContent: "end" }}>
                  <Col xs={12} className="mb-1">
                    <ChangeLanguage />
                  </Col>
                  <Col xs={"auto"}>
                    <Card.Body className="nav-link nav-user-dropdown-wrapper">
                      <Card.Body
                        className="nav-user-info"
                        data-test="component-header-placeholder-avatar"
                      >
                        <img
                          src={
                            currentUser?.photo
                              ? currentUser?.photo?.includes("users/user") ||
                                currentUser?.photo?.includes("admins/admin")
                                ? `${globalImagePath.current}${currentUser?.photo}`
                                : `${currentUser?.photo}`
                              : profilePhoto
                          }
                          className="nav-user-img"
                          alt={firstName}
                          onClick={() => setShowSubMenu(!showSubMenu)}
                          onMouseEnter={() => setShowSubMenu(true)}
                        />
                        <span className="nav-user-name">
                          {isEncryted.current
                            ? decryptedData(currentUser?.firstName)
                            : currentUser?.firstName}{" "}
                          {isEncryted.current
                            ? decryptedData(currentUser?.lastName)
                            : currentUser?.lastName}
                        </span>
                        <FontAwesomeIcon
                          className="nav-user-arrow"
                          icon={[
                            "fas",
                            showSubMenu ? "chevron-up" : "chevron-down",
                          ]}
                        />
                      </Card.Body>
                      <Card.Body
                        className="nav-user-dropdown"
                        data-test="component-header-user-dropdown"
                      >
                        {true ? (
                          <Card.Body className="nav-user-dropdown-inner">
                            {displayData?.investorDisplay ? (
                              <Link
                                id="headerInvestments"
                                className="nav-user-dropdown-item"
                                to={AppPaths.INVESTMENTS_PATH}
                                onClick={() => setShowSubMenu(false)}
                                onMouseEnter={() => preloadMyinvestmentData()}
                              >
                                {t("header.investorDashboard")}
                              </Link>
                            ) : (
                              ""
                            )}

                            {equityShareCertificates?.length > 0 &&
                            siteSettings?.enableShareCertificate === "yes" ? (
                              <Link
                                id="headerShareCertificates"
                                className="nav-user-dropdown-item"
                                to={AppPaths.SHARE_CERTIFICATES_PATH}
                                onClick={() => setShowSubMenu(false)}
                                onMouseEnter={() =>
                                  preloadEquityShareCertificateData()
                                }
                              >
                                {t("header.shareCertificate")}
                              </Link>
                            ) : (
                              ""
                            )}

                            {/* {siteSettings?.enableSecondaryMarket ===
                              secondaryMarketConstants.ENABLE && (
                              <Link
                                id="headerSecondaryMarket"
                                to={
                                  AppPaths.SECONDARY_MARKET_SELLER_DASHBOARD_PATH
                                }
                                className="nav-user-dropdown-item"
                              >
                                {t("header.secondaryMarket")}
                              </Link>
                            )} */}
                            {displayData?.campaignOwnerDisplay ? (
                              <Link
                                id="headerDashboard"
                                className="nav-user-dropdown-item"
                                to={AppPaths.DASHBOARD_PATH}
                                onClick={() => setShowSubMenu(false)}
                                onMouseEnter={() => preloadDashboardData()}
                              >
                                {t("header.campaignDashboard", {
                                  value: taxonomy?.projectSingular,
                                })}
                              </Link>
                            ) : (
                              ""
                            )}
                            <Link
                              id="headerProfilePage"
                              className="nav-user-dropdown-item"
                              to={`/profile/${localStorage.getItem("slug")}`}
                              onClick={() => setShowSubMenu(false)}
                              onMouseEnter={() =>
                                preloadUserProfileData(
                                  localStorage.getItem("slug"),
                                  props?.currentUser?.id
                                )
                              }
                            >
                              {t("header.myProfile")}
                            </Link>
                            <Link
                              id="headerSavedCampaign"
                              className="nav-user-dropdown-item"
                              to={AppPaths.SAVED_CAMPAIGN_PATH}
                              onClick={() => setShowSubMenu(false)}
                            >
                              {t("header.savedCampaign", {
                                value: taxonomy?.projectPlural,
                              })}
                            </Link>
                            {isSavedInvestmentEnable.current ? (
                              <Link
                                id="headerSavedInvestment"
                                className="nav-user-dropdown-item"
                                to={AppPaths.SAVED_INVESTMENT_PATH}
                                onClick={() => setShowSubMenu(false)}
                              >
                                {t("header.savedInvestment")}
                              </Link>
                            ) : null}
                            {/* Comment : this below message functionality is not used anywhere */}

                            {/* <Link
                        		id="headerInbox"
                        		className="nav-user-dropdown-item dropdown-item-messages"
                        		to={AppPaths.INBOX_PATH}
                        		onClick={() => setShowSubMenu(false)}
                        	>
                        		{t("header.messages")}
                        	</Link> */}
                            <Link
                              id="headerNotification"
                              className="nav-user-dropdown-item dropdown-item-notifications"
                              to={AppPaths.USER_NOTIFICATION_PATH}
                              onClick={() => {
                                dispatch(actions.postUserNotifications());
                                setShowSubMenu(false);
                              }}
                            >
                              {t("header.notifications")}
                            </Link>
                            <Link
                              id="headerInvite"
                              className="nav-user-dropdown-item"
                              to={AppPaths.INVITE_PATH}
                              onClick={() => setShowSubMenu(false)}
                            >
                              {t("header.inviteFriends")}
                            </Link>
                            {siteSettings?.walletModule === "yes" ? (
                              <Link
                                id="headerProfileSetting"
                                className="nav-user-dropdown-item"
                                to={AppPaths.WALLET_PATH}
                                onClick={() => setShowSubMenu(false)}
                                onMouseEnter={() =>
                                  preloadWalletData(
                                    walletSelectedCurrency?.id ||
                                      siteSettings?.currencyId?.id
                                  )
                                }
                              >
                                {t("wallet.title")}
                              </Link>
                            ) : null}
                            {siteSettings?.mangoPayModule === "yes" ? (
                              <Link
                                id="headerProfileSetting"
                                className="nav-user-dropdown-item"
                                to={AppPaths.MANGOPAY_PATH}
                                onClick={() => setShowSubMenu(false)}
                                onMouseEnter={() =>
                                  preloadMangoPayData(
                                    siteSettings?.mangoPayCurrencyId?.id
                                  )
                                }
                              >
                                {t("header.mangoPayWallet")}
                              </Link>
                            ) : null}
                            <Link
                              id="headerProfileSetting"
                              className="nav-user-dropdown-item"
                              to={AppPaths.PROFILE_SETTINGS_PATH}
                              onClick={() => setShowSubMenu(false)}
                            >
                              {t("header.settings")}
                            </Link>

                            <Link
                              id="headerLogout"
                              className="nav-user-dropdown-item"
                              data-test="component-header-logout"
                              to={AppPaths.LOGOUT_PATH}
                              onClick={() => setShowSubMenu(false)}
                            >
                              {t("header.logout")}
                            </Link>
                          </Card.Body>
                        ) : null}
                      </Card.Body>
                    </Card.Body>
                  </Col>
                  {/* <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip id="tooltipNotifications">
                      {t("header.notifications")}
                    </Tooltip>
                  }>
                  <Link
                    id="headerNotificationDesktop"
                    className="nav-link top-notification ms-3 unread-number"
                    to={AppPaths.USER_NOTIFICATION_PATH}
                    onClick={() => dispatch(actions.postUserNotifications())}>
                    <FontAwesomeIcon icon={["fas", "bell"]} />
                    {userNotifications?.unreadCount > 0 ? (
                      <span className="top-notification-count">
                        {userNotifications?.unreadCount}
                      </span>
                    ) : null}
                  </Link>
                </OverlayTrigger> */}
                  {displayData?.headerRaiseCapital && (
                    <Col xs={"auto"}>
                      <Button
                        onClick={() => navigate(AppPaths.PROJECT_GUIDELINES)}
                        className="square-btn square-btn-shadow"
                      >
                        {i18n.t("header.getStarted")}
                      </Button>
                    </Col>
                  )}
                </Row>
              </>
            ) : (
              <>
                <Card.Body>
                  <ChangeLanguage />
                  <Card.Body className="d-flex justify-content-end gap-2 mt-2">
                    <Link
                      id="headerLogin"
                      className="nav-link"
                      to={AppPaths.LOGIN_PATH}
                      data-test="component-header-login"
                    >
                      <Button className="square-btn-outline">
                        {t("menu.signIn")}
                      </Button>
                    </Link>
                    <Link
                      id="headerSignup"
                      className="nav-link btn btn-primary square-btn square-btn-shadow"
                      to={AppPaths.SIGNUP_PATH}
                    >
                      {t("menu.signUp")}
                    </Link>
                  </Card.Body>
                </Card.Body>
              </>
            )}
          </Card.Body>
        </Container>
      </Navbar>
      <Card.Body
        className={classNames("top-spacing", isHome ? "d-none" : "")}
      ></Card.Body>
    </>
  );
}

export default compose(withTranslation())(Header);
